import { render, staticRenderFns } from "./Tree_Point.vue?vue&type=template&id=2f37fcc0"
import script from "./Tree_Point.vue?vue&type=script&lang=js"
export * from "./Tree_Point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports